// extracted by mini-css-extract-plugin
export default {"link":"privacy_link__oBZ2r","modalOverlay":"privacy_modalOverlay__+4IBO","modalContent":"privacy_modalContent__QFLfU","closeButton":"privacy_closeButton__EjHGb"};